import React, { Component } from 'react';
import { connect } from 'react-redux';
import Row from './../row';
import { iconEmpty } from './../../../../../services/helper'

class Rows extends Component {
    renderRows = () => {
        if (this.props.orders.length) {
            let orderNew = []
            for (let i = 0; i < this.props.orders.length; i++) {
                let orderCurrent = this.props.orders[i]
                let obj = {}
                obj[orderCurrent.key] = orderCurrent.ID
                orderNew.push(
                    <Row
                        key={i}
                        i={i}
                        obj={obj}
                    />
                )
            }
            return orderNew
        } else {
            return (
                <tr style={{ width: '100%', textAlign: 'center' }}>
                    <td colSpan={8}>{iconEmpty()}</td>
                </tr>
            )
        }
    }

    render() {
        return (
            <tbody>
                {this.renderRows()}
            </tbody>
        );
    }
}

const mapStateToProps = state => {
    return {
        orders: state.ordersReducer.orders,
    }
}

export default connect(
    mapStateToProps,
    null
)(Rows)


// WEBPACK FOOTER //
// ./src/containers/orders/list/components/rows/index.js